module.exports = __webpack_public_path__ + "static/img/2.85fc263.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/2.png
// module id = Rhco
// module chunks = 1